import { useState } from 'react'

import { providerName } from '../format'
import type { GpuProvider, ProviderPatch } from '../hooks/useGpuAdmin'
import { usePatchGpuProvider } from '../hooks/useGpuMutations'
import { MarkupModal } from './MarkupModal'

export interface ProviderControls {
  onToggleSales: (provider: GpuProvider, next: boolean) => Promise<void>
  onToggleSpot: (provider: GpuProvider, next: boolean) => Promise<void>
  onEditMarkup: (provider: GpuProvider) => void
}

// Sales, spot and markup edits shared by the provider list and card.
export function useProviderControls() {
  const patch = usePatchGpuProvider()
  const [editing, setEditing] = useState<GpuProvider>()

  const send = (provider: GpuProvider, body: ProviderPatch) =>
    patch.mutateAsync({ key: provider.key, patch: body }).then(
      () => undefined,
      () => undefined,
    )

  const controls: ProviderControls = {
    onToggleSales: (provider, next) => send(provider, { sales_enabled: next }),
    onToggleSpot: (provider, next) =>
      send(provider, { spot_sales_enabled: next }),
    onEditMarkup: setEditing,
  }

  const markupModal = editing && (
    <MarkupModal
      open
      target={providerName(editing.key)}
      current={editing.markup_percent}
      inheritLabel="Use global markup"
      loading={patch.isPending}
      onSubmit={(value) =>
        patch.mutateAsync({
          key: editing.key,
          patch: { markup_percent: value },
        })
      }
      onClose={() => setEditing(undefined)}
    />
  )

  return { controls, markupModal }
}
